import "./image.scss"

function Image(
  {src, alt = "", ...rest}
) {
  return <img className="Mini-img" src={src} alt={alt} {...rest} />;
}
export default Image;